import _suggestCloseCircleFill from "@zenlayer/zen-design-icons/assets/suggest/CloseCircleFill.svg";
import _generalEllipsis from "@zenlayer/zen-design-icons/assets/general/Ellipsis.svg";
import Button from '../button';
import Dropdown from '../dropdown';
import Icon from '../icon';
import Space from '../space';
import Tooltip from '../tooltip';
import { useUpdateEffect } from 'ahooks';
import classNames from 'classnames';
import { drop, take } from 'ramda';
import React, { useMemo, useState, createElement as _createElement } from 'react';
import { useConfig } from '../hooks/useConfig';
import { getTransedText } from '../locale';
import { createMenu } from './tbodyOpts/ActionMenu';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const SelectionModal = props => {
  const {
    selectedRowKeys,
    onChange,
    operation,
    otherOperation,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style
  } = props;
  const {
    locale: {
      Table: TableLocale
    }
  } = useConfig();
  const baseClassName = "".concat(prefixClass, "-selectionModal");
  const [visible, setVisible] = useState(!!(selectedRowKeys !== null && selectedRowKeys !== void 0 && selectedRowKeys.length));
  useUpdateEffect(() => {
    setVisible(!!(selectedRowKeys !== null && selectedRowKeys !== void 0 && selectedRowKeys.length));
  }, [selectedRowKeys]);
  const [calculateOpts, calculateOtherOpts] = useMemo(() => {
    const availableOpt = (operation === null || operation === void 0 ? void 0 : operation.filter(i => !!i)) || [];
    const optNum = availableOpt.length;
    const availableOtherOpt = (otherOperation === null || otherOperation === void 0 ? void 0 : otherOperation.filter(i => !i.hidden)) || [];
    const otherOptNum = availableOtherOpt.length;
    if (otherOptNum > 0 && optNum < 2) {
      return [[...availableOpt, take(2 - optNum, availableOtherOpt).map(item => {
        const tooltipProps = item.tooltips ? item.tooltips : {
          title: undefined
        };
        return /*#__PURE__*/_createElement(Tooltip, {
          ...tooltipProps,
          key: item.key
        }, /*#__PURE__*/_jsx(Button, {
          size: "s",
          type: "normal",
          disabled: item.disabled,
          danger: item.danger,
          onClick: item.onClick,
          children: item.text
        }));
      })], drop(2 - optNum, availableOtherOpt)];
    } else {
      return [availableOpt, availableOtherOpt];
    }
  }, [operation, otherOperation]);
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: classNames(baseClassName, className),
    style: style,
    children: /*#__PURE__*/_jsx("div", {
      className: "content",
      children: /*#__PURE__*/_jsxs(Space, {
        align: "center",
        size: "ll",
        children: [/*#__PURE__*/_jsx("span", {
          children: getTransedText(TableLocale.selectionModal_total, {
            selectedTotal: selectedRowKeys === null || selectedRowKeys === void 0 ? void 0 : selectedRowKeys.length
          })
        }), !!calculateOpts.length && /*#__PURE__*/_jsx(Space, {
          align: "center",
          children: calculateOpts
        }), !!calculateOtherOpts.length && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "divider",
            children: "|"
          }), /*#__PURE__*/_jsx(Dropdown, {
            placement: "top",
            getPopupContainer: t => t.parentNode,
            menu: createMenu(calculateOtherOpts),
            children: /*#__PURE__*/_jsx(Button, {
              type: "normal",
              size: "s",
              textBaseColor: true,
              icon: /*#__PURE__*/_jsx(Icon, {
                type: "general/Ellipsis"
              })
            })
          })]
        }), /*#__PURE__*/_jsx(Icon, {
          type: "suggest/CloseCircleFill",
          className: "closeIcon",
          fontSize: 24,
          onClick: () => {
            onChange([]);
            setVisible(false);
          }
        })]
      })
    })
  });
};
export default SelectionModal;